import api from "../config/api";
import handleResponse from "./ResponseHandler";

function validateJwt(token: string) {
    return new Promise(function (resolve, reject) {
        const options = {
            method: "POST",
            headers: {
                Accept: "application/json, text/plain, */*",
                token: token,
                "Content-Type": "application/json"
            }
        };

        const url = "/login";
        fetch(api.jwtValidation + url, options)
            .then((response) => handleResponse(response))
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((response) =>
                reject({
                    status: response.statusText,
                    statusCode: response.statusCode
                })
            );
    });
}

export default validateJwt;
